/**
 * Generated by orval
 * Do not edit manually.
 * IP Fabric API
 * IP Fabric API documentation. For details see [IP Fabric API documentation](https://docs.ipfabric.io/main/IP_Fabric_API/)
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetRetrieveBgpSettings200Item,
  GetRetrieveShowRoute200,
  GetRetrieveShowRoutes200Item,
  GetSettings200,
  GetTablesSettings200,
  GetTablesSettingsParams,
  PatchSettings200,
  PatchSettingsBody,
  PostAddBgpSettingsBody,
  PostAddShowRoutesBody,
  PostApplianceConfigurationExportBody,
  PostApplianceConfigurationImportBody,
  PostSettingsVendorApiVerifyConnectionReverifyBody,
  PostSnapshotsSnapshotIdSettingsVendorApiVerifyConnectionReverifyBody,
} from '../../schemas';

import { apiClient } from '../../../apiClient';

/**
 * Schedules a configuration export job that exports the provided configuration options (admins only).
 * @summary Schedule a configuration export job
 */
export const postApplianceConfigurationExport = (
  postApplianceConfigurationExportBody: PostApplianceConfigurationExportBody,
  signal?: AbortSignal,
) => {
  return apiClient<void>({
    url: `/appliance-configuration/export`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postApplianceConfigurationExportBody,
    signal,
  });
};

export const getPostApplianceConfigurationExportMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApplianceConfigurationExport>>,
    TError,
    { data: PostApplianceConfigurationExportBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApplianceConfigurationExport>>,
  TError,
  { data: PostApplianceConfigurationExportBody },
  TContext
> => {
  const mutationKey = ['postApplianceConfigurationExport'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApplianceConfigurationExport>>,
    { data: PostApplianceConfigurationExportBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApplianceConfigurationExport(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApplianceConfigurationExportMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApplianceConfigurationExport>>
>;
export type PostApplianceConfigurationExportMutationBody =
  PostApplianceConfigurationExportBody;
export type PostApplianceConfigurationExportMutationError = void;

/**
 * @summary Schedule a configuration export job
 */
export const usePostApplianceConfigurationExport = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApplianceConfigurationExport>>,
      TError,
      { data: PostApplianceConfigurationExportBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApplianceConfigurationExport>>,
  TError,
  { data: PostApplianceConfigurationExportBody },
  TContext
> => {
  const mutationOptions =
    getPostApplianceConfigurationExportMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Schedules a configuration import job that import the provided configuration (admins only).
 * @summary Schedule a configuration import job
 */
export const postApplianceConfigurationImport = (
  postApplianceConfigurationImportBody: PostApplianceConfigurationImportBody,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append(`file`, postApplianceConfigurationImportBody.file);
  formData.append(
    `passphrase`,
    postApplianceConfigurationImportBody.passphrase,
  );

  return apiClient<void>({
    url: `/appliance-configuration/import`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getPostApplianceConfigurationImportMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApplianceConfigurationImport>>,
    TError,
    { data: PostApplianceConfigurationImportBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApplianceConfigurationImport>>,
  TError,
  { data: PostApplianceConfigurationImportBody },
  TContext
> => {
  const mutationKey = ['postApplianceConfigurationImport'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApplianceConfigurationImport>>,
    { data: PostApplianceConfigurationImportBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApplianceConfigurationImport(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApplianceConfigurationImportMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApplianceConfigurationImport>>
>;
export type PostApplianceConfigurationImportMutationBody =
  PostApplianceConfigurationImportBody;
export type PostApplianceConfigurationImportMutationError = void;

/**
 * @summary Schedule a configuration import job
 */
export const usePostApplianceConfigurationImport = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApplianceConfigurationImport>>,
      TError,
      { data: PostApplianceConfigurationImportBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApplianceConfigurationImport>>,
  TError,
  { data: PostApplianceConfigurationImportBody },
  TContext
> => {
  const mutationOptions =
    getPostApplianceConfigurationImportMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns all available global settings
 * @summary Return global settings
 */
export const getSettings = (signal?: AbortSignal) => {
  return apiClient<GetSettings200>({ url: `/settings`, method: 'GET', signal });
};

export const getGetSettingsQueryKey = () => {
  return [`/settings`] as const;
};

export const getGetSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettings>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettings>>> = ({
    signal,
  }) => getSettings(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettings>>
>;
export type GetSettingsQueryError = unknown;

export function useGetSettings<
  TData = Awaited<ReturnType<typeof getSettings>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettings>>,
          TError,
          Awaited<ReturnType<typeof getSettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSettings<
  TData = Awaited<ReturnType<typeof getSettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettings>>,
          TError,
          Awaited<ReturnType<typeof getSettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSettings<
  TData = Awaited<ReturnType<typeof getSettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Return global settings
 */

export function useGetSettings<
  TData = Awaited<ReturnType<typeof getSettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSettingsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Modified global settings for selected properties.

**Authentication methods:** Each `credential` must have either a `password` or `privateKey`. 
`passphrase` is optional and only used to unlock an encrypted `privateKey`.

**Security notice:** An SSH private key is sensitive information. When you add it here, 
IP Fabric stores it encrypted and uses it to authenticate to matching network devices. 
Only add keys that are approved for this purpose and limited to the required devices.

**Important:** Once created, credentials cannot be retrieved in plaintext form
due to encryption. Only updates and deletions are supported via their UUID.

 * @summary Modify global settings
 */
export const patchSettings = (patchSettingsBody: PatchSettingsBody) => {
  return apiClient<PatchSettings200>({
    url: `/settings`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchSettingsBody,
  });
};

export const getPatchSettingsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSettings>>,
    TError,
    { data: PatchSettingsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchSettings>>,
  TError,
  { data: PatchSettingsBody },
  TContext
> => {
  const mutationKey = ['patchSettings'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchSettings>>,
    { data: PatchSettingsBody }
  > = (props) => {
    const { data } = props ?? {};

    return patchSettings(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchSettings>>
>;
export type PatchSettingsMutationBody = PatchSettingsBody;
export type PatchSettingsMutationError = unknown;

/**
 * @summary Modify global settings
 */
export const usePatchSettings = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchSettings>>,
      TError,
      { data: PatchSettingsBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchSettings>>,
  TError,
  { data: PatchSettingsBody },
  TContext
> => {
  const mutationOptions = getPatchSettingsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Retrieves all bgp settings
 * @summary Retrieve bgp settings
 */
export const getRetrieveBgpSettings = (signal?: AbortSignal) => {
  return apiClient<GetRetrieveBgpSettings200Item[]>({
    url: `/settings/bgp`,
    method: 'GET',
    signal,
  });
};

export const getGetRetrieveBgpSettingsQueryKey = () => {
  return [`/settings/bgp`] as const;
};

export const getGetRetrieveBgpSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getRetrieveBgpSettings>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getRetrieveBgpSettings>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRetrieveBgpSettingsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRetrieveBgpSettings>>
  > = ({ signal }) => getRetrieveBgpSettings(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRetrieveBgpSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRetrieveBgpSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRetrieveBgpSettings>>
>;
export type GetRetrieveBgpSettingsQueryError = void;

export function useGetRetrieveBgpSettings<
  TData = Awaited<ReturnType<typeof getRetrieveBgpSettings>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRetrieveBgpSettings>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRetrieveBgpSettings>>,
          TError,
          Awaited<ReturnType<typeof getRetrieveBgpSettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRetrieveBgpSettings<
  TData = Awaited<ReturnType<typeof getRetrieveBgpSettings>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRetrieveBgpSettings>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRetrieveBgpSettings>>,
          TError,
          Awaited<ReturnType<typeof getRetrieveBgpSettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRetrieveBgpSettings<
  TData = Awaited<ReturnType<typeof getRetrieveBgpSettings>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRetrieveBgpSettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieve bgp settings
 */

export function useGetRetrieveBgpSettings<
  TData = Awaited<ReturnType<typeof getRetrieveBgpSettings>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRetrieveBgpSettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetRetrieveBgpSettingsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Adds a new bgp settings to the global settings
 * @summary Add bgp settings
 */
export const postAddBgpSettings = (
  postAddBgpSettingsBody: PostAddBgpSettingsBody,
  signal?: AbortSignal,
) => {
  return apiClient<void>({
    url: `/settings/bgp`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postAddBgpSettingsBody,
    signal,
  });
};

export const getPostAddBgpSettingsMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAddBgpSettings>>,
    TError,
    { data: PostAddBgpSettingsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAddBgpSettings>>,
  TError,
  { data: PostAddBgpSettingsBody },
  TContext
> => {
  const mutationKey = ['postAddBgpSettings'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAddBgpSettings>>,
    { data: PostAddBgpSettingsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postAddBgpSettings(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAddBgpSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAddBgpSettings>>
>;
export type PostAddBgpSettingsMutationBody = PostAddBgpSettingsBody;
export type PostAddBgpSettingsMutationError = void;

/**
 * @summary Add bgp settings
 */
export const usePostAddBgpSettings = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAddBgpSettings>>,
      TError,
      { data: PostAddBgpSettingsBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAddBgpSettings>>,
  TError,
  { data: PostAddBgpSettingsBody },
  TContext
> => {
  const mutationOptions = getPostAddBgpSettingsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Remove bgp settings from global settings
 * @summary Remove bgp settings
 */
export const deleteRemoveBgpSettings = (bgpId: string) => {
  return apiClient<void>({ url: `/settings/bgp/${bgpId}`, method: 'DELETE' });
};

export const getDeleteRemoveBgpSettingsMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRemoveBgpSettings>>,
    TError,
    { bgpId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteRemoveBgpSettings>>,
  TError,
  { bgpId: string },
  TContext
> => {
  const mutationKey = ['deleteRemoveBgpSettings'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteRemoveBgpSettings>>,
    { bgpId: string }
  > = (props) => {
    const { bgpId } = props ?? {};

    return deleteRemoveBgpSettings(bgpId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteRemoveBgpSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteRemoveBgpSettings>>
>;

export type DeleteRemoveBgpSettingsMutationError = void;

/**
 * @summary Remove bgp settings
 */
export const useDeleteRemoveBgpSettings = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteRemoveBgpSettings>>,
      TError,
      { bgpId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteRemoveBgpSettings>>,
  TError,
  { bgpId: string },
  TContext
> => {
  const mutationOptions = getDeleteRemoveBgpSettingsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Checks Custom Discovery Data definition texts (YAML) as discovery loads them. Returns one result per definition, in request order: the name of a valid definition, or why an invalid one does not load (including a name an earlier valid definition already has).
 * @summary Check Custom Discovery Data definitions
 */
export const postSettingsCustomDiscoveryDefinitionsValidate = (
  signal?: AbortSignal,
) => {
  return apiClient<unknown>({
    url: `/settings/custom-discovery-definitions/validate`,
    method: 'POST',
    signal,
  });
};

export const getPostSettingsCustomDiscoveryDefinitionsValidateMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postSettingsCustomDiscoveryDefinitionsValidate>
      >,
      TError,
      void,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postSettingsCustomDiscoveryDefinitionsValidate>>,
    TError,
    void,
    TContext
  > => {
    const mutationKey = ['postSettingsCustomDiscoveryDefinitionsValidate'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postSettingsCustomDiscoveryDefinitionsValidate>
      >,
      void
    > = () => {
      return postSettingsCustomDiscoveryDefinitionsValidate();
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostSettingsCustomDiscoveryDefinitionsValidateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postSettingsCustomDiscoveryDefinitionsValidate>>
  >;

export type PostSettingsCustomDiscoveryDefinitionsValidateMutationError =
  unknown;

/**
 * @summary Check Custom Discovery Data definitions
 */
export const usePostSettingsCustomDiscoveryDefinitionsValidate = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postSettingsCustomDiscoveryDefinitionsValidate>
      >,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSettingsCustomDiscoveryDefinitionsValidate>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getPostSettingsCustomDiscoveryDefinitionsValidateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Retrieves all show routes settings
 * @summary Retrieve show routes settings
 */
export const getRetrieveShowRoutes = (signal?: AbortSignal) => {
  return apiClient<GetRetrieveShowRoutes200Item[]>({
    url: `/settings/show-routes`,
    method: 'GET',
    signal,
  });
};

export const getGetRetrieveShowRoutesQueryKey = () => {
  return [`/settings/show-routes`] as const;
};

export const getGetRetrieveShowRoutesQueryOptions = <
  TData = Awaited<ReturnType<typeof getRetrieveShowRoutes>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getRetrieveShowRoutes>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRetrieveShowRoutesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRetrieveShowRoutes>>
  > = ({ signal }) => getRetrieveShowRoutes(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRetrieveShowRoutes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRetrieveShowRoutesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRetrieveShowRoutes>>
>;
export type GetRetrieveShowRoutesQueryError = void;

export function useGetRetrieveShowRoutes<
  TData = Awaited<ReturnType<typeof getRetrieveShowRoutes>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRetrieveShowRoutes>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRetrieveShowRoutes>>,
          TError,
          Awaited<ReturnType<typeof getRetrieveShowRoutes>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRetrieveShowRoutes<
  TData = Awaited<ReturnType<typeof getRetrieveShowRoutes>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRetrieveShowRoutes>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRetrieveShowRoutes>>,
          TError,
          Awaited<ReturnType<typeof getRetrieveShowRoutes>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRetrieveShowRoutes<
  TData = Awaited<ReturnType<typeof getRetrieveShowRoutes>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRetrieveShowRoutes>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieve show routes settings
 */

export function useGetRetrieveShowRoutes<
  TData = Awaited<ReturnType<typeof getRetrieveShowRoutes>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRetrieveShowRoutes>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetRetrieveShowRoutesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Adds a new show routes settings to the global settings
 * @summary Add show routes settings
 */
export const postAddShowRoutes = (
  postAddShowRoutesBody: PostAddShowRoutesBody,
  signal?: AbortSignal,
) => {
  return apiClient<void>({
    url: `/settings/show-routes`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postAddShowRoutesBody,
    signal,
  });
};

export const getPostAddShowRoutesMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAddShowRoutes>>,
    TError,
    { data: PostAddShowRoutesBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAddShowRoutes>>,
  TError,
  { data: PostAddShowRoutesBody },
  TContext
> => {
  const mutationKey = ['postAddShowRoutes'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAddShowRoutes>>,
    { data: PostAddShowRoutesBody }
  > = (props) => {
    const { data } = props ?? {};

    return postAddShowRoutes(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAddShowRoutesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAddShowRoutes>>
>;
export type PostAddShowRoutesMutationBody = PostAddShowRoutesBody;
export type PostAddShowRoutesMutationError = void;

/**
 * @summary Add show routes settings
 */
export const usePostAddShowRoutes = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAddShowRoutes>>,
      TError,
      { data: PostAddShowRoutesBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAddShowRoutes>>,
  TError,
  { data: PostAddShowRoutesBody },
  TContext
> => {
  const mutationOptions = getPostAddShowRoutesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Remove show route from global settings
 * @summary Remove show route
 */
export const deleteRemoveShowRoute = (id: string) => {
  return apiClient<void>({
    url: `/settings/show-routes/${id}`,
    method: 'DELETE',
  });
};

export const getDeleteRemoveShowRouteMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRemoveShowRoute>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteRemoveShowRoute>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteRemoveShowRoute'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteRemoveShowRoute>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteRemoveShowRoute(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteRemoveShowRouteMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteRemoveShowRoute>>
>;

export type DeleteRemoveShowRouteMutationError = void;

/**
 * @summary Remove show route
 */
export const useDeleteRemoveShowRoute = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteRemoveShowRoute>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteRemoveShowRoute>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteRemoveShowRouteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Retrieve a specific show route from global settings
 * @summary Retrieve show route
 */
export const getRetrieveShowRoute = (id: string, signal?: AbortSignal) => {
  return apiClient<GetRetrieveShowRoute200>({
    url: `/settings/show-routes/${id}`,
    method: 'GET',
    signal,
  });
};

export const getGetRetrieveShowRouteQueryKey = (id: string) => {
  return [`/settings/show-routes/${id}`] as const;
};

export const getGetRetrieveShowRouteQueryOptions = <
  TData = Awaited<ReturnType<typeof getRetrieveShowRoute>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRetrieveShowRoute>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRetrieveShowRouteQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRetrieveShowRoute>>
  > = ({ signal }) => getRetrieveShowRoute(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRetrieveShowRoute>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRetrieveShowRouteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRetrieveShowRoute>>
>;
export type GetRetrieveShowRouteQueryError = void;

export function useGetRetrieveShowRoute<
  TData = Awaited<ReturnType<typeof getRetrieveShowRoute>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRetrieveShowRoute>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRetrieveShowRoute>>,
          TError,
          Awaited<ReturnType<typeof getRetrieveShowRoute>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRetrieveShowRoute<
  TData = Awaited<ReturnType<typeof getRetrieveShowRoute>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRetrieveShowRoute>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRetrieveShowRoute>>,
          TError,
          Awaited<ReturnType<typeof getRetrieveShowRoute>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRetrieveShowRoute<
  TData = Awaited<ReturnType<typeof getRetrieveShowRoute>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRetrieveShowRoute>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieve show route
 */

export function useGetRetrieveShowRoute<
  TData = Awaited<ReturnType<typeof getRetrieveShowRoute>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRetrieveShowRoute>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetRetrieveShowRouteQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Tests the connection for an existing vendor API configuration
 * @summary Verify connection for existing vendor API
 */
export const postSettingsVendorApiVerifyConnectionId = (
  id: string,
  signal?: AbortSignal,
) => {
  return apiClient<void>({
    url: `/settings/vendor-api/verify-connection/${id}`,
    method: 'POST',
    signal,
  });
};

export const getPostSettingsVendorApiVerifyConnectionIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSettingsVendorApiVerifyConnectionId>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSettingsVendorApiVerifyConnectionId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postSettingsVendorApiVerifyConnectionId'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSettingsVendorApiVerifyConnectionId>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postSettingsVendorApiVerifyConnectionId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSettingsVendorApiVerifyConnectionIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSettingsVendorApiVerifyConnectionId>>
>;

export type PostSettingsVendorApiVerifyConnectionIdMutationError = void;

/**
 * @summary Verify connection for existing vendor API
 */
export const usePostSettingsVendorApiVerifyConnectionId = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSettingsVendorApiVerifyConnectionId>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSettingsVendorApiVerifyConnectionId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions =
    getPostSettingsVendorApiVerifyConnectionIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Tests the connection for an existing vendor API configuration with updated credentials
 * @summary Reverify connection for existing vendor API
 */
export const postSettingsVendorApiVerifyConnectionReverify = (
  postSettingsVendorApiVerifyConnectionReverifyBody: PostSettingsVendorApiVerifyConnectionReverifyBody,
  signal?: AbortSignal,
) => {
  return apiClient<void>({
    url: `/settings/vendor-api/verify-connection/reverify`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postSettingsVendorApiVerifyConnectionReverifyBody,
    signal,
  });
};

export const getPostSettingsVendorApiVerifyConnectionReverifyMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSettingsVendorApiVerifyConnectionReverify>>,
    TError,
    { data: PostSettingsVendorApiVerifyConnectionReverifyBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSettingsVendorApiVerifyConnectionReverify>>,
  TError,
  { data: PostSettingsVendorApiVerifyConnectionReverifyBody },
  TContext
> => {
  const mutationKey = ['postSettingsVendorApiVerifyConnectionReverify'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSettingsVendorApiVerifyConnectionReverify>>,
    { data: PostSettingsVendorApiVerifyConnectionReverifyBody }
  > = (props) => {
    const { data } = props ?? {};

    return postSettingsVendorApiVerifyConnectionReverify(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSettingsVendorApiVerifyConnectionReverifyMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postSettingsVendorApiVerifyConnectionReverify>>
  >;
export type PostSettingsVendorApiVerifyConnectionReverifyMutationBody =
  PostSettingsVendorApiVerifyConnectionReverifyBody;
export type PostSettingsVendorApiVerifyConnectionReverifyMutationError = void;

/**
 * @summary Reverify connection for existing vendor API
 */
export const usePostSettingsVendorApiVerifyConnectionReverify = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSettingsVendorApiVerifyConnectionReverify>>,
      TError,
      { data: PostSettingsVendorApiVerifyConnectionReverifyBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSettingsVendorApiVerifyConnectionReverify>>,
  TError,
  { data: PostSettingsVendorApiVerifyConnectionReverifyBody },
  TContext
> => {
  const mutationOptions =
    getPostSettingsVendorApiVerifyConnectionReverifyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Tests the connection for a specific vendor API configuration in a snapshot's settings
 * @summary Verify connection for specific vendor API settings
 */
export const postSnapshotsKeySettingsVendorApiVerifyConnectionVendorSettingsId =
  (key: string, vendorSettingsId: string, signal?: AbortSignal) => {
    return apiClient<void>({
      url: `/snapshots/${key}/settings/vendor-api/verify-connection/${vendorSettingsId}`,
      method: 'POST',
      signal,
    });
  };

export const getPostSnapshotsKeySettingsVendorApiVerifyConnectionVendorSettingsIdMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postSnapshotsKeySettingsVendorApiVerifyConnectionVendorSettingsId
        >
      >,
      TError,
      { key: string; vendorSettingsId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof postSnapshotsKeySettingsVendorApiVerifyConnectionVendorSettingsId
      >
    >,
    TError,
    { key: string; vendorSettingsId: string },
    TContext
  > => {
    const mutationKey = [
      'postSnapshotsKeySettingsVendorApiVerifyConnectionVendorSettingsId',
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postSnapshotsKeySettingsVendorApiVerifyConnectionVendorSettingsId
        >
      >,
      { key: string; vendorSettingsId: string }
    > = (props) => {
      const { key, vendorSettingsId } = props ?? {};

      return postSnapshotsKeySettingsVendorApiVerifyConnectionVendorSettingsId(
        key,
        vendorSettingsId,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostSnapshotsKeySettingsVendorApiVerifyConnectionVendorSettingsIdMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof postSnapshotsKeySettingsVendorApiVerifyConnectionVendorSettingsId
      >
    >
  >;

export type PostSnapshotsKeySettingsVendorApiVerifyConnectionVendorSettingsIdMutationError =
  void;

/**
 * @summary Verify connection for specific vendor API settings
 */
export const usePostSnapshotsKeySettingsVendorApiVerifyConnectionVendorSettingsId =
  <TError = void, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof postSnapshotsKeySettingsVendorApiVerifyConnectionVendorSettingsId
          >
        >,
        TError,
        { key: string; vendorSettingsId: string },
        TContext
      >;
    },
    queryClient?: QueryClient,
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof postSnapshotsKeySettingsVendorApiVerifyConnectionVendorSettingsId
      >
    >,
    TError,
    { key: string; vendorSettingsId: string },
    TContext
  > => {
    const mutationOptions =
      getPostSnapshotsKeySettingsVendorApiVerifyConnectionVendorSettingsIdMutationOptions(
        options,
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Tests the connection for an existing vendor API configuration with updated credentials for the snapshot
 * @summary Reverify connection for existing vendor API for snapshot
 */
export const postSnapshotsSnapshotIdSettingsVendorApiVerifyConnectionReverify =
  (
    snapshotId: string,
    postSnapshotsSnapshotIdSettingsVendorApiVerifyConnectionReverifyBody: PostSnapshotsSnapshotIdSettingsVendorApiVerifyConnectionReverifyBody,
    signal?: AbortSignal,
  ) => {
    return apiClient<void>({
      url: `/snapshots/${snapshotId}/settings/vendor-api/verify-connection/reverify`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postSnapshotsSnapshotIdSettingsVendorApiVerifyConnectionReverifyBody,
      signal,
    });
  };

export const getPostSnapshotsSnapshotIdSettingsVendorApiVerifyConnectionReverifyMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postSnapshotsSnapshotIdSettingsVendorApiVerifyConnectionReverify
        >
      >,
      TError,
      {
        snapshotId: string;
        data: PostSnapshotsSnapshotIdSettingsVendorApiVerifyConnectionReverifyBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof postSnapshotsSnapshotIdSettingsVendorApiVerifyConnectionReverify
      >
    >,
    TError,
    {
      snapshotId: string;
      data: PostSnapshotsSnapshotIdSettingsVendorApiVerifyConnectionReverifyBody;
    },
    TContext
  > => {
    const mutationKey = [
      'postSnapshotsSnapshotIdSettingsVendorApiVerifyConnectionReverify',
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postSnapshotsSnapshotIdSettingsVendorApiVerifyConnectionReverify
        >
      >,
      {
        snapshotId: string;
        data: PostSnapshotsSnapshotIdSettingsVendorApiVerifyConnectionReverifyBody;
      }
    > = (props) => {
      const { snapshotId, data } = props ?? {};

      return postSnapshotsSnapshotIdSettingsVendorApiVerifyConnectionReverify(
        snapshotId,
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostSnapshotsSnapshotIdSettingsVendorApiVerifyConnectionReverifyMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof postSnapshotsSnapshotIdSettingsVendorApiVerifyConnectionReverify
      >
    >
  >;
export type PostSnapshotsSnapshotIdSettingsVendorApiVerifyConnectionReverifyMutationBody =
  PostSnapshotsSnapshotIdSettingsVendorApiVerifyConnectionReverifyBody;
export type PostSnapshotsSnapshotIdSettingsVendorApiVerifyConnectionReverifyMutationError =
  void;

/**
 * @summary Reverify connection for existing vendor API for snapshot
 */
export const usePostSnapshotsSnapshotIdSettingsVendorApiVerifyConnectionReverify =
  <TError = void, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof postSnapshotsSnapshotIdSettingsVendorApiVerifyConnectionReverify
          >
        >,
        TError,
        {
          snapshotId: string;
          data: PostSnapshotsSnapshotIdSettingsVendorApiVerifyConnectionReverifyBody;
        },
        TContext
      >;
    },
    queryClient?: QueryClient,
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof postSnapshotsSnapshotIdSettingsVendorApiVerifyConnectionReverify
      >
    >,
    TError,
    {
      snapshotId: string;
      data: PostSnapshotsSnapshotIdSettingsVendorApiVerifyConnectionReverifyBody;
    },
    TContext
  > => {
    const mutationOptions =
      getPostSnapshotsSnapshotIdSettingsVendorApiVerifyConnectionReverifyMutationOptions(
        options,
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Retrieve settings for a specific table for the user
 * @summary GET /tables/settings
 */
export const getTablesSettings = (
  params: GetTablesSettingsParams,
  signal?: AbortSignal,
) => {
  return apiClient<GetTablesSettings200>({
    url: `/tables/settings`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetTablesSettingsQueryKey = (
  params: GetTablesSettingsParams,
) => {
  return [`/tables/settings`, ...(params ? [params] : [])] as const;
};

export const getGetTablesSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTablesSettings>>,
  TError = unknown,
>(
  params: GetTablesSettingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTablesSettings>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTablesSettingsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTablesSettings>>
  > = ({ signal }) => getTablesSettings(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTablesSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTablesSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTablesSettings>>
>;
export type GetTablesSettingsQueryError = unknown;

export function useGetTablesSettings<
  TData = Awaited<ReturnType<typeof getTablesSettings>>,
  TError = unknown,
>(
  params: GetTablesSettingsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTablesSettings>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTablesSettings>>,
          TError,
          Awaited<ReturnType<typeof getTablesSettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTablesSettings<
  TData = Awaited<ReturnType<typeof getTablesSettings>>,
  TError = unknown,
>(
  params: GetTablesSettingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTablesSettings>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTablesSettings>>,
          TError,
          Awaited<ReturnType<typeof getTablesSettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTablesSettings<
  TData = Awaited<ReturnType<typeof getTablesSettings>>,
  TError = unknown,
>(
  params: GetTablesSettingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTablesSettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary GET /tables/settings
 */

export function useGetTablesSettings<
  TData = Awaited<ReturnType<typeof getTablesSettings>>,
  TError = unknown,
>(
  params: GetTablesSettingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTablesSettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTablesSettingsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
